import { Injectable, inject } from '@angular/core';
import { PLATFORM_CONFIG } from '@platform/config';
import type { PlatformConfig } from '@platform/config';

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagService {
  private readonly config = inject<PlatformConfig>(PLATFORM_CONFIG);

  /**
   * Check if a feature is enabled
   */
  isEnabled(featureName: string): boolean {
    const feature = this.config.features[featureName];
    if (!feature) {
      return false;
    }

    if (!feature.enabled) {
      return false;
    }

    // If rollout percentage is specified, check it
    if (feature.rolloutPercentage !== undefined) {
      const random = Math.random() * 100;
      return random < feature.rolloutPercentage;
    }

    return true;
  }

  /**
   * Get feature configuration
   */
  getFeature(featureName: string) {
    return this.config.features[featureName];
  }

  /**
   * Get all enabled features
   */
  getEnabledFeatures(): string[] {
    return Object.keys(this.config.features).filter(featureName =>
      this.isEnabled(featureName)
    );
  }
}

